<template>
  <CarouselWrapper
    v-if="!isFetching && items?.length"
    id="product-page-suggestions"
    data-cy-region="cross-sell-products-slider"
    :products="items"
    :title="$t('mayLike')"
    :subtitle="$t('subtitle')"
  />
</template>

<script setup lang="ts">
defineComponent({
  name: 'ProductPageSuggestions',
});
const { product } = useProductContext();
const { data: items, pending: isFetching } = useAsyncData(async () => {
  const response = await useRelatedProducts(product.value?.sku || '');

  return response;
});
</script>

<i18n>
{
  "en": {
    "subtitle": "- PRODUCTS FOR YOU",
    "mayLike": "Complete The Look"
  },
  "ar": {
    "subtitle": "- منتجات لك",
    "mayLike": "اكمل المظهر"
  }
}
</i18n>
